import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/auth/useAuth'

/** Layout-роут без пути: оборачивает раздел целиком, чтобы не забыть защиту на новом экране. */
export function RequireAuth() {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />
}

export function RequireAnon() {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />
}
